export enum DeliveryStatusEnum {
  INITIAL = 'INITIAL',
  PICKEDUP = 'PICKEDUP',
  INTRAVEL = 'INTRAVEL',
  IMMINENT_DELIVERY = 'IMMINENT_DELIVERY',
  DELIVERED = 'DELIVERED',
  PROBLEM = 'PROBLEM',
  CANCELED = 'CANCELED',
}
